import { useTranslation } from 'react-i18next';

export const useLabel = () => {
  const { t } = useTranslation();

  const convertLabelLayer = (layer) => {
    switch (layer) {
      case 'drawn':
        return t('layer.sidewalks_painted_label');
      case 'described':
        return t('layer.sidewalks_saved_label');
      case 'theoretical':
        return t('layer.sidewalks_theory_label');
      case 'no_sidewalk':
        return t('layer.no_sidewalk_label');
      case 'walk':
        return t('layer.walk_path_label');
      case 'walk_cycle':
        return t('layer.walk_cycle_label');
      case 'crossing_point':
        return t('layer.crosswalk_point_label');
      case 'crossing_path':
        return t('layer.crosswalk_line_label');
      default:
        return '';
    }
  };

  const convertExplainLabel = (layer) => {
    switch (layer) {
      case 'drawn':
        return t('layer.sidewalks_painted_desc');
      case 'described':
        return t('layer.sidewalks_saved_desc');
      case 'theoretical':
        return t('layer.sidewalks_theory_desc');
      case 'no_sidewalk':
        return t('layer.no_sidewalk_desc');
      case 'walk':
        return t('layer.walk_path_desc');
      case 'walk_cycle':
        return t('layer.walk_cycle_desc');
      case 'crossing_point':
        return t('layer.crosswalk_point_desc');
      case 'crossing_path':
        return t('layer.crosswalk_line_desc');
      default:
        return '';
    }
  };

  return {
    convertLabelLayer,
    convertExplainLabel,
  };
};
